import { PaginatedResponse } from '@/calendesk/models/DTO/Response/Interface/PaginatedResponse'
import { Expose, Type } from 'class-transformer'
import UserSubscription from '@/calendesk/models/DTO/Response/UserSubscription'

export default class UserSubscriptionsResponse extends PaginatedResponse {
  @Expose()
  @Type(() => UserSubscription)
  public data!: Array<UserSubscription>
}
